import { IComponentOptions } from "angular";

export const vsComponentName = "contractDetailComponent";

export const contractDetailComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controller: [function () {}],
  controllerAs: "contractDetailComponentController",
  bindings: {
    contract: "<",
  },
};
